// src/templates/index.js
//
// Registro central de plantillas.
// Cada plantilla tiene su componente React que se renderiza directamente
// tanto en el preview del card (escalado) como en el modal y en el PDF.

import TechBlue from "./cotizacion/TechBlue";
// import Corporativa    from "./cotizacion/Corporativa";    // TODO: crear
// import Minimalista    from "./cotizacion/Minimalista";    // TODO: crear
// import FacturaModerna from "./factura/Moderna";           // TODO: crear
// import FacturaClasica from "./factura/Clasica";           // TODO: crear
// import RemisionEst    from "./remision/Estandar";         // TODO: crear
// import OrdenFormal    from "./orden-compra/Formal";       // TODO: crear

export const TEMPLATES = [

  // ── Cotizaciones ───────────────────────────────────────────────────────────
  {
    id: "cotizacion-tech-blue",
    name: "Tecnológica (Tech Blue)",
    type: "cotizacion",
    component: TechBlue,       // ← componente real
  },
  {
    id: "cotizacion-corporativa",
    name: "Corporativa Ejecutiva",
    type: "cotizacion",
    component: null,           // TODO: import Corporativa
  },
  {
    id: "cotizacion-minimalista",
    name: "Minimalista Dark",
    type: "cotizacion",
    component: null,           // TODO: import Minimalista
  },

  // ── Facturas ───────────────────────────────────────────────────────────────
  {
    id: "factura-moderna",
    name: "Moderna Clean",
    type: "factura",
    component: null,           // TODO: import FacturaModerna
  },
  {
    id: "factura-clasica",
    name: "Clásica Profesional",
    type: "factura",
    component: null,           // TODO: import FacturaClasica
  },

  // ── Remisiones ─────────────────────────────────────────────────────────────
  {
    id: "remision-estandar",
    name: "Estándar",
    type: "remision",
    component: null,           // TODO: import RemisionEst
  },

  // ── Órdenes de Compra ──────────────────────────────────────────────────────
  {
    id: "orden-compra-formal",
    name: "Formal",
    type: "orden-compra",
    component: null,           // TODO: import OrdenFormal
  },
];

/**
 * Devuelve las plantillas filtradas por tipo y ordenadas.
 */
export function getTemplatesByType(type, sortBy = "recent") {
  const filtered = TEMPLATES.filter((t) => t.type === type);

  switch (sortBy) {
    case "name-asc":
      return [...filtered].sort((a, b) => a.name.localeCompare(b.name));
    case "name-desc":
      return [...filtered].sort((a, b) => b.name.localeCompare(a.name));
    case "old":
      return [...filtered].reverse();
    case "recent":
    default:
      return filtered;
  }
}

/**
 * Devuelve una plantilla por su id.
 */
export function getTemplateById(id) {
  return TEMPLATES.find((t) => t.id === id);
}